module.exports = __webpack_public_path__ + "img/schema_recherche_unitaire_lineaire_explication.38a6852f.jpg";